let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("aq0V6")).then(() => parcelRequire('i0mY9'));